import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiModalModule } from '../si-modal';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
  imports: [
    DisableAutocompleteDirectiveModule,
    CommonModule,
    SiModalModule,
  ],
})
export class MakeListsPublicPromptSaveSearchModule {}
